import { h, render } from 'preact'
import App from './containers/App'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const container = document.getElementById('js-references-overview')

if ( container ) {
  const language = container.dataset.language
  render( <App language={language} />, container )
}



// WEBPACK FOOTER //
// ./src/js/references/index.js